module.exports = __webpack_public_path__ + "static/media/tecs.7c040276.png";